import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { DumboProps } from './types';
import Hidden from './Hidden';
import Premium from './Premium';

export function useDumboCommon(props: DumboProps) {
  const { showBlocked } = useDeviationMatureFilter(props.deviation);
  const mature_blur = useFlag('mature_blur');

  if (!props.deviation) {
    return null;
  }

  if (showBlocked && !props.showMatureContent) {
    // most images will be blurred on the backend (with mature_blur)
    // so no need to handle it differently (unless asked to force clientside handling)
    return mature_blur && !props.handleMatureOnClientside ? null : (
      <Hidden {...props} />
    );
  }

  const { isPremiumLocked } = normalizePremiumFolderData(
    props.deviation?.premiumFolderData
  );

  if (isPremiumLocked) {
    return <Premium {...props} />;
  }
}
